// 鹭愿卡
const routes = [
  // ----------------------------------- 鹭愿卡-首页 ----------------------------------------
  {
    path: '/luyuanIndex',
    name: 'luyuanIndex',
    component: () => import('@/views/XiameBank/luyuan/index.vue'),
    meta: {
      requiresAuth: false,
      title: '财富晋升计划'
    }
  },
  {
    // 鹭愿卡-分享页面
    path: '/luyuanShare',
    name: 'luyuanShare',
    component: () => import('@/views/XiameBank/luyuan/share.vue'),
    meta: {
      requiresAuth: false,
      title: '财富晋升计划'
    }
  },
  // ----------------------------------- 鹭愿卡-新客礼项目T1006643 ----------------------------------------
  {
    path: '/luyuanNewCustomerGift',
    name: 'luyuanNewCustomerGift',
    component: () => import('@/views/XiameBank/luyuan/newCustomerGift'),
    meta: {
      requiresAuth: false,
      title: '鹭启新财.新客晋级礼'
    }
  },
  {
    path: '/luyuanNewCustomerGiftWxDetail',
    name: 'luyuanNewCustomerGiftWxDetail',
    component: () =>
      import('@/views/XiameBank/luyuan/newCustomerGift/wxDetail'),
    meta: {
      requiresAuth: true,
      title: '鹭启新财.新客晋级礼'
    }
  },
  {
    path: '/luyuanNewCustomerGiftDetail',
    name: 'luyuanNewCustomerGiftDetail',
    component: () =>
      import('@/views/XiameBank/luyuan/newCustomerGift/detail'),
    meta: {
      requiresAuth: false,
      title: '鹭启新财.新客晋级礼'
    }
  },
  {
    path: "/luyuanNewCustomerGiftPhysicalDetail",
    name: "luyuanNewCustomerGiftPhysicalDetail",
    component: () => import("@/views/XiameBank/luyuan/newCustomerGift/physicalDetail.vue"),
    meta: {
      requiresAuth: false,
      title: "鹭启新财.新客晋级礼",
    }
  },
  {
    path: "/luyuanNewCustomerGiftAddressForm",
    name: "luyuanNewCustomerGiftAddressForm",
    component: () => import("@/views/XiameBank/luyuan/newCustomerGift/addressForm.vue"),
    meta: {
      requiresAuth: false,
      title: "鹭启新财.新客晋级礼",
    },
  },

  // ----------------------------------- 鹭愿卡-提升礼 ----------------------------------------
  {
    path: "/luyuanPromotionGift",
    name: "luyuanPromotionGift",
    component: () => import("@/views/XiameBank/luyuan/promotionGift/index.vue"),
    meta: {
      requiresAuth: false,
      title: "鹭启升金.财富进阶礼",
    },
  },
  // 实物领取详情界面
  {
    path: "/luyuanPromotionGiftPhysicalDetail",
    name: "luyuanPromotionGiftPhysicalDetail",
    component: () => import("@/views/XiameBank/luyuan/promotionGift/physicalDetail.vue"),
    meta: {
      requiresAuth: false,
      title: "鹭启升金.财富进阶礼",
    },
  },
  // 领取详情界面
  {
    path: "/luyuanPromotionGiftDetail",
    name: "luyuanPromotionGiftDetail",
    component: () => import("@/views/XiameBank/luyuan/promotionGift/detail.vue"),
    meta: {
      requiresAuth: false,
      title: "鹭启升金.财富进阶礼",
    },
  },
  // 跳转微信小程序领取立减金界面
  {
    path: "/luyuanPromotionGiftWxDetail",
    name: "luyuanPromotionGiftWxDetail",
    component: () => import("@/views/XiameBank/luyuan/promotionGift/wxDetail.vue"),
    meta: {
      requiresAuth: true, // 需要微信登录
      title: "鹭启升金.财富进阶礼",
    }
  },
  // 领取失败详情界面
  {
    path: "/luyuanPromotionGiftFailDetail",
    name: "luyuanPromotionGiftFailDetail",
    component: () => import("@/views/XiameBank/luyuan/promotionGift/failDetail.vue"),
    meta: {
      requiresAuth: false,
      title: "鹭启升金.财富进阶礼",
    },
  },
  // 实物商品收货地址填写界面
  {
    path: "/luyuanPromotionGiftAddressForm",
    name: "luyuanPromotionGiftAddressForm",
    component: () => import("@/views/XiameBank/luyuan/promotionGift/addressForm.vue"),
    meta: {
      requiresAuth: false,
      title: "鹭启升金.财富进阶礼",
    },
  },
  // ----------------------------------- 鹭愿卡-维稳礼（财富续航）xibMaintain ----------------------------------------
  {
    path: '/luyuanXibMaintain',
    name: 'luyuanXibMaintain',
    component: () => import('@/views/XiameBank/luyuan/xibMaintain/index.vue'),
    meta: {
      requiresAuth: false,
      title: '厦门国际银行财富续航',
    },
  },
  {
    path: '/luyuanXibMaintainSuccessResultPage',
    name: 'luyuanXibMaintainSuccessResultPage',
    component: () =>
      import('@/views/XiameBank/luyuan/xibMaintain/successResultPage.vue'),
    meta: {
      requiresAuth: false,
      title: '厦门国际银行财富续航',
    },
  },
  {
    path: '/luyuanXibMaintainWxDetail',
    name: 'luyuanXibMaintainWxDetail',
    component: () => import('@/views/XiameBank/luyuan/xibMaintain/wxDetail.vue'),
    meta: {
      requiresAuth: true,
      title: '厦门国际银行财富续航',
    },
  },
  {
    path: '/luyuanXibMaintainAddressForm',
    name: 'luyuanXibMaintainAddressForm',
    component: () =>
      import('@/views/XiameBank/luyuan/xibMaintain/components/addressForm.vue'),
    meta: {
      requiresAuth: false,
      title: '厦门国际银行财富续航',
    },
  },
  {
    path: '/luyuanXibMaintainPhysicalDetail',
    name: 'luyuanXibMaintainPhysicalDetail',
    component: () =>
      import('@/views/XiameBank/luyuan/xibMaintain/components/physicalDetail.vue'),
    meta: {
      requiresAuth: false,
      title: '厦门国际银行财富续航',
    },
  },
]

export default routes
